module.exports = __webpack_public_path__ + "static/media/Soybean6AfterV9.8beb96fd.PNG";